module.exports = __webpack_public_path__ + "img/side1.97f4e68b.png";